
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/who-we-are-hero.webp';
import highResMobileImageWebp from './images/who-we-are-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='who-we-are-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='About Northwestern Mutual'
      headingText={
        <>
          A better way to money&#174; <WidowBlock>starts here.</WidowBlock>
        </>
      }
      descriptionText={
        <>
          A better conversation uncovers the opportunities that can lead to a better plan and a life better than you ever imagined. It&#39;s what your advisor is there for. And it&#39;s why we do what we&#39;ve been doing for over <WidowBlock>165 years.</WidowBlock>
        </>
      }
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get started',
        ariaLabel: 'Get started with a financial advisor today.',
        children: '',
      }}
      backgroundImageAriaLabel='Two friends sitting outside on a porch while enjoying a cup of tea'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
